module.exports = __webpack_public_path__ + "static/media/09.640ef852.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/boulders/09.jpg
// module id = 468
// module chunks = 0